module.exports = __webpack_public_path__ + "img/sort-oysters.e7a04173.webp";